import { useSearchParams } from "next/navigation"

  

/**
 * Returns the current search params
 * Example:
 * const searchParams = useCurrentSearchParams()
 * console.log(searchParams)
 * // { search: "John Doe", page: "1", limit: "10" }
 */
export function useCurrentSearchParams<
    T extends Record<string, string | number | boolean | string[] | number[] | null | undefined>,
>(
    pickKeys?: (keyof T)[]
) {
    const searchParams = useSearchParams()
    const previousParams: Record<string, string | string[]> = {}
    
    // Handle array parameters (e.g., ?roles=Volunteer&roles=TeamLeader)
    for (const [key, value] of searchParams.entries()) {
        if (previousParams[key]) {
            // Convert to array if it already exists
            if (Array.isArray(previousParams[key])) {
                (previousParams[key] as string[]).push(value)
            } else {
                previousParams[key] = [previousParams[key] as string, value]
            }
        } else {
            previousParams[key] = value
        }
    }
    
    if (!pickKeys) {
        return previousParams as T
    }
    const filteredParams = Object.entries(previousParams)
        .filter(([key]) => pickKeys.includes(key as keyof T))
        
    return Object.fromEntries(filteredParams) as T
}